import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../config/axios';
import { testCorsConnection } from '../utils/corsTest';
import { debugConnection, testAdminLogin } from '../utils/debugConnection';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('checking');
  const [connectionDetails, setConnectionDetails] = useState('');
  const navigate = useNavigate();

  // Test connection on component mount
  useEffect(() => {
    const testConnection = async () => {
      const result = await testCorsConnection();
      setConnectionStatus(result.success ? 'connected' : 'failed');
      setConnectionDetails(result.message || result.error || '');
      if (!result.success) {
        console.error('Connection test failed:', result);
      } else {
        console.log('Connection test successful:', result);
      }
    };
    testConnection();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('Attempting login with API URL:', api.defaults.baseURL);
      const response = await api.post('/admin/login', {
        email,
        password
      });

      if (response.data.token) {
        // Store token for future requests
        localStorage.setItem('authToken', response.data.token);
        navigate('/dashboard');
      } else {
        setError('Invalid credentials');
      }
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 401) {
        setError('Invalid email or password');
      } else if (error.code === 'ERR_NETWORK') {
        setError('Unable to connect to server. Please check your connection and ensure the backend is running.');
      } else {
        setError('Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleDebug = async () => {
    console.log('Running debug connection test...');
    await debugConnection();
  };

  const getConnectionStatusText = () => {
    switch (connectionStatus) {
      case 'checking':
        return 'Checking connection...';
      case 'connected':
        return connectionDetails || '✓ Connected to server';
      case 'failed':
        return connectionDetails || '✗ Connection failed - check backend server';
      default:
        return 'Unknown status';
    }
  };

  return (
    <div className="login-container">
      <div className="container">
        <div className="login-card">
          <h1>AarogAI Admin Panel</h1>
          <h2>Login</h2>
          
          {/* Connection status indicator */}
          <div className={`connection-status ${connectionStatus}`}>
            {getConnectionStatusText()}
          </div>
          
          {error && (
            <div className="alert alert-error">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password:</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading || connectionStatus === 'failed'}
              style={{ width: '100%', marginBottom: '1rem' }}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          {/* Debug button - remove this in production */}
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={handleDebug}
            style={{ width: '100%', fontSize: '0.8rem' }}
          >
            Debug Connection (Check Console)
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login; 